export default "__VITE_ASSET__CBuEAKvt__"